var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('RodoSearch',{on:{"searchClickEvent":_vm.searchClicked,"quarantineClickEvent":_vm.quarantineClicked,"exportClickEvent":_vm.exportClicked}}),_c('RodoTable',{ref:"rodoTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }